<template>
<div class="col-2">
<div class="content_card_content left_panel">
<div class="flex justify-content-between flex-wrap align-items-center">
<h4 class="text-primary my-0">Katmanlar</h4>
<Button icon="pi pi-plus" class=" p-button-primary p-button-text  p-button-sm" @click="addParentBlock"></Button>
</div>
<hr/>
<div class="left_panel_content">
<draggable 
v-model="schema"
data_container_id="parent"
group="parent" 
@start="start" 
@end="end" 
@change="change"
handle=".handle"
v-bind="dragOptions"
item-key="id">
<template #item="{element}">
<SchemaEditorBlockLine 
:block="element" 
@deleteBlock="deleteBlock"
@addCloneBlock="addCloneBlock"
/>

</template>
</draggable>
</div>



</div>
</div>
</template>

<script>
import SchemaEditorBlockLine from "./SchemaEditorBlockLine"
export default {

  name: 'SchemaEditorBlocks',
  data () {
    return {
    	schema:[],
    	drag:false,
    }
  },
  components:{SchemaEditorBlockLine},
  watch:{
    blocks(newval,oldval)
    {
      this.schema = this.$store.state.customresultdisplays.schema
    },
  },
  computed:{
    blocks()
    {
      return this.$store.state.customresultdisplays.schema
    },
    deletedstate()
    {
      return this.$store.state.ui.deletedstate
    },
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  methods:{
    deleteBlock(id)
    {
      if(this.$store.state.customresultdisplays.selected_element && id == this.$store.state.customresultdisplays.selected_element.id)
      {
        this.$store.dispatch('customresultdisplays/setSelectedElement',null) 
      }
      this.schema = this.schema.filter(item=>item.id !==id)
      this.$store.dispatch('customresultdisplays/setSchema',this.schema) 
    },
    addCloneBlock(block)
    {
      this.schema.push(block)
      this.$store.dispatch('customresultdisplays/setSchema',this.schema) 
    },
  	addParentBlock()
  	{
      let id = this.generateId()
  		let grid = {
  			id:id,
  			name:"Satır",
  			type:"grid",
  			parent:null,
  			elements:[
          {
            id:this.generateId(),
            name:"Blok",
            type:"block",
            parent:id,
            elements:[]
          }
        ],
  		}
  		this.schema.push(grid)
      this.$store.dispatch('customresultdisplays/setSchema',this.schema) 
  	},
  	end(event)
    {
      this.drag = false
    },
    start(event)
    {
      this.drag = true
    },
    change(event)
    {
      this.$emit("orderChanged",this.schema)
    },
  },
}
</script>

<style lang="css" scoped>
.left_panel_content{
  min-height: 300px;
  max-height: 600px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.left_panel_content::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}
.left_panel_content::-webkit-scrollbar-track {
  border-radius: 5px;
  background-color: #fff;
}

.left_panel_content::-webkit-scrollbar-track:hover {
  background-color: #fff;
}

.left_panel_content::-webkit-scrollbar-track:active {
  background-color: #fff;
}

.left_panel_content::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #352F8D;
  border: 3px solid #FFFFFF;
}

.left_panel_content::-webkit-scrollbar-thumb:hover {
  background-color: #352F8D;
}

.left_panel_content::-webkit-scrollbar-thumb:active {
  background-color: #352F8D;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
</style>